import {
  CouponType,
  CouponValueSetting,
  RewardFields,
  RewardType,
} from "types/rewards";

export function prepareUsageLimitForRequest(
  rewardType: RewardType | CouponType | CouponValueSetting,
  values: RewardFields & {
    areAutoGeneratedCouponCodes?: string;
  },
) {
  if (
    rewardType === "material" ||
    values.areAutoGeneratedCouponCodes === "true"
  ) {
    return {
      ...(!values.usageLimit?.general
        ? { general: -1 }
        : {
            general: values.usageLimit?.general,
          }),
      ...(!values.usageLimit?.perUser
        ? { perUser: -1 }
        : { perUser: values.usageLimit?.perUser }),
    };
  } else {
    // rewardType is not material and
    // areAutoGeneratedCouponCodes is false
    return {
      ...{ general: undefined },
      ...(!values.usageLimit?.perUser
        ? { perUser: -1 }
        : { perUser: values.usageLimit?.perUser }),
    };
  }
}

export const transformTranslationsToObject = (
  translations: RewardFields["translations"],
) => {
  return translations.reduce(
    (acc, cur) => ({
      ...acc,
      [(cur.locale as string) || (cur.code as string)]: {
        name: cur.name,
        shortDescription: cur.shortDescription,
        usageInstruction: cur.usageInstruction,
        conditionsDescription: cur.conditionsDescription,
        brandDescription: cur.brandDescription,
        brandName: cur.brandName,
      },
    }),
    {},
  );
};

export const transformTranslationsToArray = (translations: {
  [key: string]: {
    brandDescription?: string;
    brandName?: string;
    conditionsDescription?: string;
    name?: string;
    languageName?: string;
    shortDescription?: string;
    usageInstruction?: string;
    code: string;
    locale?: string;
  };
}) => {
  return Object.keys(translations).map((locale) => ({
    code: locale,
    name: translations[locale].name,
    shortDescription: translations[locale].shortDescription,
    usageInstruction: translations[locale].usageInstruction,
    conditionsDescription: translations[locale].conditionsDescription,
    brandDescription: translations[locale].brandDescription,
    brandName: translations[locale].brandName,
  }));
};
